import buildObjectList from "./buildObjectList";
// Duplicated from ab-common
function buildObjectListCached(entityType) {
  var latestEntities = null;
  var cachedResponse = null;
  return function (store) {
    var entities = store.api.entities;
    if (entities === latestEntities) return cachedResponse;
    latestEntities = entities;
    cachedResponse = buildObjectList(store, entityType);
    return cachedResponse;
  };
}
export default buildObjectListCached;